export default {
	en: {
		tab: {
			article: 'Article',
			tbd: 'Article(TBD)',
			over: 'Article(Carryover)',
			bc: 'Book Chapter',
			cs: 'CS Conference'
		},

		list: {
			articleTitle: 'Title of Article',
			jnlFullNm: 'Title of Journal',

			article: {
				sourceYearMonth: 'Publication Date',
			},
			tbd: {
				sourceYearMonth: 'Expected Publication Date',
			},
			over: {
				sourceYearMonth: 'Publication Date',
			},
			bc: {
				jnlFullNm: 'Title of Book',
				bcNm: 'Title of Chapter',
				sourceYearMonth: 'Publication(Expected) Date',
				publihingDiv: 'Classification of publication',
				publihingY: 'Published'
			},
			cs: {
				articleTitle: 'Title of Article',
				sourceYearMonth: 'Expected Publication Date',
			}
		},

		detail: {
			articleTitle: 'Title of Article',
			jnlFullNm: 'Title of Journal',
			ranking: 'Ranking',
			jrnlImpactIndex: 'Impact Factor (year of publication -1)',
			rankOfJrnl: 'Journal Citation Index DB',
			creditRequestNum: 'Request for Extra Credit',
			creditRequestDesc: '(Extra-credit is awarded following application, review by department/college (Graduate School) Personal committee and final approval of Faculty Personnel committee)',
			countryNm: 'Country of Publication',
			languageCd: 'Language of Article',
			issn: 'ISSN',
			contributionYearMonth: 'Date of Submission',
			volume: 'Publication Volume',
			issue: 'Publication Book/Magazine',
			page: 'Publication Page',
			roleCd: 'Mode of Participation and Role',

			article: {
				sourceYearMonth: 'Publication Date',
				jnlSci:'SCI',
				jnlScie:'SCIE',
				jnlSsci:'SSCI',
				jnlAhcl:'A&HCI',
				jnlScopus:'SCOPUS',
				jnlImYn:'General(Internatioanl)',
				jnlKm:'General(Domestic)',
				jnlHackjin:'General(Domestic)',
				jnlHackjinCand:'KCI(Candidate)',
				jnlEtc:'ETC',
				fwci:'Field-Weighted Citation Impact (FWCI)',
				cit:'Citation',
			},
			tbd: {
				sourceYearMonth: 'Expected Publication Date'
			},
			over: {
				sourceYearMonth: 'Publication Date'
			},
			bc: {
				jnlFullNm: 'Title of Book',
				bcNm: 'Title of Chapter',
				sourceYearMonth: 'Publication(Expected) Date',
				publihingDiv: 'Classification of publication',
				publihingY: 'Published',
				publihingN: 'Book Chapter(TBD)',
				dlgtAthrNm: 'Lead Author'
			},
			cs: {
				sourceYearMonth: 'Expected Publication Date',
				contributionYearMonth: 'Date of Submission',
				jnlFullNm : 'Title of Journal',
				countryNm: 'Country of Publication',
				issn: 'Conference Code (ex. BKCS0001)',
				titleCs: 'Title of Article'
			},
			placeholder: {
				jnlFullNm: '학술지명을 검색하거나 직접 입력하실 수 있습니다.',
			},
		},

		help:{
			article:{
				title: 'Notes for articles',
				line1: {
					1: 'Articles approved by the YRI (https://yri.yonsei.ac.kr) are transferred to this system (TAMS). If the approved article is not transferred in the TAMS yet, locate the same article in the YRI and press the "Confirmation" button of the co-researcher list in the middle of the page.',
					2: "- Inquiry about YRI: yri{'@'}yonsei.ac.kr (Phone +82-2-2123-6436)",
					3: '- An article displayed on this page that YRI has not approved/confirmed is grayed out.'
				},
				line2: 'Select the required categories and press the “Save” button to calculate your achievement score. Only when the achievement point is calculated for each article can it be printed in the Performance Report.',
				line3:{
					1:'For selecting ranking of the journal, press the "Journal Rank" button to check and select the ratings. The "Dept./College’s Journal List" tab provides a list of journal approved by the Faculty  Personnel Committee.',
					2:'Please ask for the entire "Dept./College’s Journal List" to the dept. Chair to confirm.',
					3:'You can select the ranking manually without searching. '
				},
				line4: 'If your select the journal rank according to other dept./college\'s journal lists, you need approval from your dept./college personnel committee.',
				line5: 'The ranking of international articles depends on the initial submission date or publish date.',
			},
			tbd:{
				title: 'Notes for TBD achievements',
				line1: 'Please click "Add" button to register TBD articles.',
				line2:{
					1: 'The Faculty Performance Report shows all TBD achievements registered on this menu regardless of the evaluation period.',
					2: '* If your TBD achievements are published and reflected in the TAMS Article tab through the YRI appoval, you must delete them from this TBD tab or select "Not Applicable" on the article tab page to be not reflected in the Performance Report twice.',
					3: '* If you do not want to reflect the previously entered achievements in this evaluation, you must delete them.',
				},
				line3:'3. Only the research achievements that are published during the evaluation period under the affiliation of Yonsei Univeristy shall be included in the evaluation. ',
				line3Blue:'However, completed research that is in the process of being published shall also be accepted as research achievements for the evaluation, as long as sufficient evidence documentay is provided to demonstrate that the research achievements are accepted to publish.',
				line4:{
					tag:'A.',
					1:'Documentary need to be submitted for indoor TBD articles',
					2:'- A certificate of expected publication with the seal of association/publisher and expected publication date (including volume and issue), and the original full text.',
					3:'- An evaluation of the descriptive self-evaluation sheet and the evaluation sheet by the book evaluator also must be submitted in case of TBD books.'
				},
				line5:{
					tag:'B.',
					1:'Documentary need to be submitted for indoor TBD articles',
					2:'1) Web published: Acceptace Email, web published full text with volume and issue',
					3:'2) Expected to publish soon: Acceptacne Email with volume and issue, full text',
					4:'3) Do not confirm with volume and issue yet: Initial submission Email, R&R Email, Acceptance Email, full text',
				},
			},
			over:{
				title: 'How to carryover articles',
				titleStrong:'[only for pay-rasie and reappointment evaluation, and articles, books, creative activities]',
				line1: 'When articles and books are confirmed to be published after college/gradschool\'s personnel committee and the faculty member fails to include them in pay-raise or reappointment evaluation, the achievements can be carried over for next pay-raise or reappointment evaluation.',
				line2: 'Please note that achievements cannot be carried over in case of promotion evaluation.',
				line3: 'The Faculty Achievement Report shows all carryover achievements registered on this menu regardless of the evaluation period. If you need to exclude the carryover achievements on the report, then you must delete them in this menu. ',
				line4: '*Faculty Performance Evaluation Detailed Rules Article 24 (Definition of Research Results and Limitations for Acknowledgement)',
			},
			bc:{
				title: 'How to register Book Chapter ',
				line1: 'If a book approved by YRI need to be registered as a book chapter, add the achievement in this menu and click the \'Not Applicable\' on the same achievement in the "Book" menu.',
				line2: 'Book Chapters are classifed as International Tier 2, 3, 4 or Domestic Tier 3, 4. Please refer to Faculty Performance Evaluation Detailed Rules Article 27 clause 1 and Attachment table 3.',
			},
			cs:{
				title: '(Computer Science) How to register conference paper',
				line1: 'If the conference papers on the list of outstanding international academic conferences in the field of CS (Computer Science) announced by the National Research Foundation of Korea above IF 50% are classfied as \'International Tier 1\', and the rest are on the list of NRF as \'International Tier 2\'.',
				line2: 'when you register your achievement as a conferece paper on this menu, please delete the same achievement on the Academic Activity section not to count in duplicate.',
				line3: 'Effective date: from papers published after March 1, 2016',
			},
			numOfAuthors: {
				offCampus: {
					confirm: {
						1: 'Approved in advance',
						2: ': Number of domestic Institutional faculty/Researcher',
					},
					notConfirm: {
						1: 'Not Approved',
						2: ': Total number of domestic and foreign Institutional faculty/Researcher',
					}
				},
				abCampus: {
					confirm: {
						1: 'Approved in advance',
						2: ': Number of foreign Institutional faculty/Researcher',
					},
					notConfirm: {
						1: 'Not Approved',
						2: ': Blank (0)',
					}
				},
				list: {
					line1: {
						1: 'The total number of faculty, research faculty and full-time researcher filled out in the In-Campus and Off-Campus 1 sections (the highlighted ones) would be applied to calculate the points of this achievement (Faculty Performance Evaluation Detailed Rules Article 40 Clause 1).',
						2: 'The number of Ph.D. candidate and research member is excluded from calculating the points.'
					},
					line2: '* Full-time researchers: Research faculty affiliated in (University) research institurion or faculty at school (included)\n' +
						'* ETC.: Students (excluded)',
					line3: {
						1: 'If the classification above does not match the actual authorship or role of the researcher, you can adjust the number.',
						example: '',
					}
				},
				box: {
					line1: {
						1: 'When calculating evaluation points of group research, the number of researchers participating in the international group research affiliated with overseas universities or institutions ',
						2: 'can be excluded upon obtaining a permission from the dean of the affiliated college.',
						3: '(Faculty Performance Evaluation Detailed Rules Article 40 Clause 1)',
					},
					line2: {
						1: 'If you have obtained a permission from the dean of the affiliated college',
						2: ', fill out the number of domestic Institutional faculty/Researcher in the"Off-Campus 1" section and the number of foreign Institutional faculty/Researcher in the"Off-Campus 2" section.',
					},
					line3: {
						1: 'If you have not obtained a permission from the dean',
						2: ', fill out the number of domestic and foreign Institutional faculty/Researcher in the "Off-Campus 1" section and stay blank (0) in the "Off-Campus 2" section.',
					},
				},
				article: {
					title: 'See the detail Author Role (based on YRI)',
					11000: '[University] Full-time faculty',
					12000: '[University] Part-time faculty',
					13000: 'Ph.D. Candidates and etc.',
					14000: '[University] Student',
					15000: '[University] Post-doctoral(master) researcher',
					16000: '[University] Faculty/Employee of Research Center',
					17000: '[School] Teacher/faculty',
					18000: '[School] Student',
					19000: '[Other] Research Institutes and etc.',
					20000: 'Unknown',
					cnt:'{count} people | {count} person | {count} people',
				},
			}
		},
		modal:{
			journal:{
				modalTitle:'Searching Journal Rank',
				btn:'Journal Rank',
				year:'Year',
			},
		},

	},
	ko: {
		tab: {
			article: '논문',
			tbd: '논문(게재예정)',
			over: '논문(이월)',
			bc: 'Book Chapter',
			cs: 'CS분야 학술대회 논문'
		},

		list: {
			articleTitle: '논문제목',
			jnlFullNm: '학술지명',

			article: {
				sourceYearMonth: '게재년월',
			},
			tbd: {
				sourceYearMonth: '게재예정년월',
			},
			over: {
				sourceYearMonth: '게재년월',
			},
			bc: {
				jnlFullNm: '저역서명',
				bcNm: '장(Chapter)제목',
				sourceYearMonth: '출간(예정)년월',
				publihingDiv: '출간구분',
				publihingY: '출간완료'
			},
			cs: {
				articleTitle: '학술대회명',
				sourceYearMonth: '게재예정년월',
			}
		},

		detail: {
			articleTitle: '논문제목',
			jnlFullNm: '학술지명',
			ranking: '등급',
			jrnlImpactIndex: '영향력지수 (게재년도 -1)',
			rankOfJrnl: '학술지등재정보',
			creditRequestNum: '가산점 부과 신청',
			creditRequestDesc: '(가산점 부과는 본인의 신청과 학과/대학(원)인사위원회의 심사를 거쳐 교원인사위원회에서 최종 승인합니다. 해당없으시면 0을 입력하세요.)',
			countryNm: '발행국가',
			languageCd: '언어구분',
			issn: 'ISSN',
			contributionYearMonth: '투고년월',
			volume: '게재권/집',
			issue: '게재호',
			page: '게재면',
			roleCd: '참여형태 및 역할',

			article: {
				sourceYearMonth: '게재년월',
				jnlSci:'SCI',
				jnlScie:'SCIE',
				jnlSsci:'SSCI',
				jnlAhcl:'A&HCI',
				jnlScopus:'SCOPUS',
				jnlImYn:'국외일반',
				jnlKm:'국내일반',
				jnlHackjin:'학진등재',
				jnlHackjinCand:'학진등재후보',
				jnlEtc:'기타',
				fwci:'보정피인용지수',
				cit:'피인용횟수',
			},
			tbd: {
				sourceYearMonth: '게재예정년월'
			},
			over: {
				sourceYearMonth: '게재년월'
			},
			bc: {
				jnlFullNm: '저역서명',
				bcNm: '장(Chapter)제목',
				sourceYearMonth: '출간(예정)년월',
				publihingDiv: '출간구분',
				publihingY: '출간완료',
				publihingN: '출간예정',
				dlgtAthrNm: '대표저자'
			},
			cs: {
				sourceYearMonth: '개최월',
				contributionYearMonth: '발표일자',
				jnlFullNm: '학술대회명',
				countryNm: '개최국가',
				issn: '학술대회 코드 (예, BKCS0001)',
				titleCs: '학술대회 발표논문집명'
			},
			placeholder: {
				jnlFullNm: '학술지명을 검색하거나 직접 입력하실 수 있습니다.',
			},
		},

		help:{
			article:{
				title: '논문 입력 안내',
				line1: {
					1: 'YRI(https://yri.yonsei.ac.kr)에서 승인된 논문이 이 시스템(TAMS)에 반영됩니다. 만약 승인된 논문이 TAMS에 반영되지 않을 경우, YRI의 해당 논문에 들어가 페이지 중간 참여자 리스트의 저자 "확인" 버튼을 누르시기 바랍니다.',
					2: "- YRI 관련 문의: yri{'@'}yonsei.ac.kr (내선 6436)",
					3: '- 이 페이지에 표시되는 논문 리스트 중 YRI에서 아직 승인/확인되지 않은 업적은 회색으로 표기됩니다. '
				},
				line2:'필수항목을 선택하시고 저장 버튼을 누르면 업적 점수가 산정됩니다. 각 논문별로 업적점수가 산정되어야 업적 보고서에서도 출력이 가능합니다.',
				line3:{
					1:'학술지등급은 “학술지등급” 버튼을 눌러 등급을 확인하시고 선택하세요. “대학(원) 학과선정 학술지” 탭에서는 교원인사위원회에서 승인된 학과 학술지 목록을 확인할 수 있습니다. ',
					2:'* 필요시 소속 학과/대학에 해당 학술지 목록 전체를 요청하셔서 확인하시기 바랍니다.',
					3:'* 버튼을 누르지 않고 바로 등급을 선택하실 수도 있습니다.'
				},
				line4:'타대학 학술지 등급은 소속 학과/대학인사위원회에서 승인할 경우 그대로 사용할 수 있습니다.(세칙 제26조 제4항).',
				line5:'국제학술지의 논문 등급 부과는 최초 투고시점 또는 게재시점의 목록을 기준으로 합니다(세칙 제26조 제3항).',
			},
			tbd:{
				title: '논문(게재예정) 사용 안내',
				line1: '게재예정 업적은 "추가" 버튼을 클릭하여 수기 입력하십시오.',
				line2:{
					1: '이 탭에 입력한 연구업적은 업적심사기간에 상관없이 업적보고서 출력시 표기됩니다.',
					2: '* 게재예정 업적이 출판되어 TAMS 논문 탭에 반영된 경우, 본 예정 탭에서 해당 업적을 삭제하시거나 논문 탭의 동일 업적을 “심사제외” 하셔야 보고서에 이중으로 반영되지 않습니다.',
					3: '* 이전에 입력된 게재예정 업적을 금번 심사에 반영하지 않으시려면 반드시 삭제하셔야 합니다.',
				},
				line3:'심사대상기간 동안 연세대학교 이름으로 게재·발간된 실적물만을 연구업적의 평가대상으로 함이 원칙이나, ',
				line3Blue:'연구가 완료되었으나 그 연구결과가 아직 발간되지 아니한 경우에는 연구실적을 인정할 수 있는 자료와 그 실적물에 대한 게재·출판 예정증명이 있으면 해당 평가 기간의 연구업적으로 평가할 수 있음 (「교원업적평가 시행세칙」 제24조 제2항).',
				line4:{
					tag:'가.',
					1:'국내 예정 논문(저술) 제출시 증명',
					2:'- 해당 학회 혹은 출판사의 직인 및 게재예정일(권, 호 포함)이 명시된 게재예정증명서와 해당 업적 원문(full text)',
					3:'- 게재 예정 저술도 자기평가서 및 심사위원저술평가서 작성 필수 '
				},
				line5:{
					tag:'나.',
					1:'국제 예정 논문(저술) 제출시 증명',
					2:'1) 웹게시되었을 경우: Acceptace Email과 웹게시(웹용 권/호가 명시된) 논문',
					3:'2) 게재예정일이 곧 도래하는 경우: Acceptacne Email, 게재예정 권/호가 명시된 이메일, 업적 원문(full text)',
					4:'3) 게재예정일(권/호)을 확인할 수 없을 때: 최초 투고 이메일, 중간수정요청 이메일, 최종 Acceptance 이메일, 업적 원문(full text)',
				},
			},
			over:{
				title: '연구업적 이월 사용 안내 ',
				titleStrong:'[승봉/재임용 심사 및 논문/저술/창작활동에 한함]',
				line1: '논문 및 저술이 업적이 대학(원)인사위원회 개최 후 게재,출판이 확정되어 승봉심사와 재임용심사에서 사용하지 못하였을 경우 각각 차기 승봉심사와 재임용심사에 이월하여 사용할 수 있습니다.',
				line2: '승진심사의 경우 업적을 이월할 수 없으니 유의하시기 바랍니다.',
				line3: '이 탭에 입력한 연구업적은 업적심사기간에 상관없이 업적보고서에 표시될 수 있습니다. 만약 업적심사에 반영하지 않으시려면 반드시 삭제하셔야 합니다.',
				line4: '관련 근거 : 「교원업적평가 시행세칙」 제24조(연구실적물의 정의와 인정범위) 제7항',
			},
			bc:{
				title: 'Book Chapter 안내',
				line1: 'YRI에 입력한 저역서를 논문 Book Chapter로 인정받으시려면, 이 페이지에서 해당 Book Chapter를 수기 입력하신 후, 저역서 페이지에서 해당 동일 업적을 "심사제외"로 클릭하시기 바랍니다.',
				line2: 'Book Chapter는 「교원업적평가 시행세칙」제27조 제1항 [별표3]에 따라, 국제2,3,4등급 및 국내 3,4등급으로만 등급을 부여할 수 있습니다.',
			},
			cs:{
				title: '(Computer Science) 분야 우수 국제학술대회 논문 입력 안내',
				line1: '한국연구재단 발표 CS(Computer Science) 분야 우수 국제학술대회 목록에 포함된 학술대회 논문집으로 IF가 목록 내에서 상위 50% 이상에 해당할 경우 국제1등급으로 인정하고, 나머지는 국제 2등급으로 인정합니다.',
				line2: '연구업적이 이중 반영되지 않도록, 이 탭에서 국제학술대회 논문으로 입력할 경우, 해당 업적을 ‘연구업적평가 > 그 외 연구활동 > 학술활동’ 탭에서 ‘심사제외’로 클릭하여 주시기 바랍니다.',
				line3: '시행일 : 2016. 3. 1. 이후 발표된 논문부터',
			},
			numOfAuthors:{
				offCampus:{
					confirm:{
						1:'사전승인시',
						2:': 국내기관교원/연구원 수만 기재',
					},
					notConfirm:{
						1:'사전미승인시',
						2:': 국내외기관교원/연구원 총원 기재',
					}
				},
				abCampus:{
					confirm:{
						1:'사전승인시',
						2:': 국외기관교원/연구원 수만 기재',
					},
					notConfirm:{
						1:'사전미승인시',
						2:': 공란 처리',
					}
				},
				list:{
					line1:{
						1: '교내, 교외1 행에 입력된 ‘교원, 비전임교원 및 전임연구원’ 수는 「교원업적평가 시행세칙」 제40조 제1항에 따라 공동연구업적 연구평점 산정시 반영',
						2: '되며, ‘박사 후 과정 및 기타’ 연구자 수는 보조 연구자이므로 반영되지 않습니다. (음영 부분만 반영)'
					},
					line2:'현재 [대학]연구소 연구원/직원/기타, [초중고교]교사, [대학 외]연구소 연구원 등은 전임연구원으로 분류되고, [대학]학생(학,석,박사), [초중고교]학생, 불분명은 기타로 분류되어 있습니다.(전임연구원은 연구평점 산정시 반영되고, 기타는 미반영)',
					line3:{
						1: '위 분류가 실제 수행한 연구자의 저자역할과 일치하지 않을 경우, 숫자를 조정할 수 있습니다.',
						example: '예: [대학]연구소 연구원/직원/기타 1명이 전임연구원으로 분류되어 있으나, 실제로는 연구보조업무를 수행하였으므로 기타로 조정',
					}
				},
				box:{
					line1:{
						1:'공동연구에 대한 평가점수 산정시 해외 대학 혹은 기관에 소속되어 국제간공동연구로 참여하는 연구자의 수는 ',
						2:'소속 대학 내부 절차에 따라 소속 대학(원)장의 승인을 얻어 포함하지 않을 수 있습니다.',
						3:'(근거 : 「교원업적평가 시행세칙」 제40조 제1항)',
					},
					line2:{
						1:'소속 대학(원)장의 승인을 받은 경우',
						2:', 교외 1에는 국내 소재 기관 소속 교원/연구원 수를 입력하고 교외 2에 해외 소재 기관 소속 교원/연구원 수를 입력합니다.',
					},
					line3:{
						1:'소속 대학(원)장의 승인을 받지 아니한 경우',
						2:', 교외 1에는 국내 및 국외 소재 기관 소속 교원/연구원 수를 입력하고 교외 2 입력란은 공란으로 비워두시면 됩니다.',
					},
				},
				article:{
					title:'저자역할 상세현황 (YRI 입력기준)',
					11000:'[대학]전임교원',
					12000:'[대학]비전임교원',
					13000:'박사후 과정 및 연구조원(저자변경전 입력시)',
					14000:'[대학]학생(학,석,박사)',
					15000:'[대학]박사후(석사후)연구원',
					16000:'[대학]연구소 연구원/직원/기타',
					17000:'[초중고교]교사',
					18000:'[초중고교]학생',
					19000:'[대학 외]연구소 연구원 등',
					20000:'불분명',
					cnt:'{count}명 | {count}명 | {count}명',
				},
			}
		},
		modal:{
			journal:{
				modalTitle:'학술지등급조회',
				btn:'학술지등급',
				year:'년도',
			},
		},
	}
}